/**
 * Everything on the page that is words rather than structure.
 */
export const NAME = "Ata Ahmad";

export const ROLES = [
  "Software Engineer",
  "Photographer",
  "CBVA Volleyball Player",
];

export const BULLETS = [
  "I studied Physics at UC Santa Barbara, where I also picked up a knack for programming.",
  "I learned JavaScript in two weeks for an interview at PayPal, and started there right out of school.",
  { text: "I was laid off from PayPal, but landed a role at Platform Science, where I built things I am genuinely proud of." },
  "I eventually made my way to Google, where I am now a Software Engineer on the Bandwidth SRE Team.",
  { text: "I've had plenty of titles in my life, but the one I love the most is builder. My purpose in life is to build things that can make the world a better place.", soft: true },
];

/**
 * The contact address. Clearing this string removes the link entirely;
 * the label below can read "Bookings" instead if photography enquiries
 * should be framed that way.
 */
export const EMAIL = "ata.ahmad9@gmail.com";

export const LINKS = [
  { label: "LinkedIn", href: "https://www.linkedin.com/in/ataahmad9/" },
  { label: "GitHub", href: "https://github.com/ataahmad" },
  ...(EMAIL ? [{ label: "Email", href: `mailto:${EMAIL}` }] : []),
];
